// UploadedFilesList.js
import FileItem from "../fileItem/FileItem";

const UploadedFilesList = ({ groupedFiles, onRemoveFile, isImporting }) => (
  <div className="uploaded-files-wrapper">
    <ul className="uploaded-files">
      {groupedFiles.length === 0 ? (
        <p></p>
      ) : (
        groupedFiles.map(group => (
          <li key={group.seriesId || (group.files[0] && group.files[0].name)}>
          <FileItem
            key={group.seriesId || (group.files[0] && group.files[0].name)}
            group={group}
            onRemove={() => onRemoveFile(group)}
            isImporting={isImporting}
          />
          </li>
        ))
      )}
    </ul>
  </div>
);

export default UploadedFilesList;
